import styled from "styled-components";

export const MainStyled = styled.div`
  height: ${({ theme }) =>
      !["xm"].includes(theme.windowWidth) ? "60vh" : "none"}
    10px; ;
`;
